'use client';

import React from 'react';
import { Tab, TabPanel } from '@headlessui/react';
import { JobList as GateJobList, useJobs } from '@gate-js/react';
import { RenderItem } from './RenderItem';
import { getTabClasses, getTabStyle } from './tabHelpers';

export function GroupTrigger({
	value, label, tabColor, activeTabColor, tabBackground, activeTabBackground, tabBorderColor, tabBorderWidth, tabRounded, tabsStyle, tabsLayout,
}) {
	const { jobs } = useJobs();

	// Count jobs in this group
	const jobCount = value === 'all' ? jobs.length : jobs?.filter((job) => job.groups?.includes(value)).length || 0;

	return (
		<Tab>
			{({ selected }) => (
				<div
					style={getTabStyle({
						selected, tabsLayout, tabsStyle, tabColor, activeTabColor, tabBackground, activeTabBackground, tabBorderColor, tabBorderWidth,
					})}
					className={getTabClasses(tabRounded)}
				>
					{label || value}
					{' '}
					(
					{jobCount}
					)
				</div>
			)}
		</Tab>
	);
}

export function GroupContent({ index, value, className, style }) {
	return (
		<TabPanel value={String(index)}>
			<GateJobList
				renderItem={RenderItem}
				group={value}
				className={className}
				style={style}
			/>
		</TabPanel>
	);
}
